import InnerScreenHeader from "@/components/layout/inner-screen-header"
import AccountForm from "./account.form"
import { useUser } from "@/api/users"
import Loader from "@/components/layout/loader"
import AccountDeleteForm from "./account-delete.form"

export default function AccountScreen() {
  const { user } = useUser()

  if (!user) {
    return <Loader message="Loading user..." />
  }

  return (
    <div className="flex flex-col gap-4">
      <InnerScreenHeader title="Settings" to="/settings" />
      <AccountForm user={user} />
      <AccountDeleteForm />
    </div>
  )
}
